'use strict';

require("core-js/modules/es7.object.define-getter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.addCustomTypes = exports.Schema = exports.t = void 0;

var _typy = require('./typy'),
    _typy2 = _interopRequireDefault(_typy);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var t = function t(a, b) {
  return new _typy2["default"]().t(a, b);
},
    Schema = _typy2["default"].Schema,
    addCustomTypes = function addCustomTypes(a) {
  if (t(a).isObject) Object.keys(a).forEach(function (b) {
    if (t(a[b]).isFunction) _typy2["default"].prototype.__defineGetter__(b, function () {
      return a[b](this.input);
    });else throw new Error('validator ' + b + ' is not a function');
  });else throw new Error('validators must be key value pairs');
};

exports["default"] = t, exports.t = t, exports.Schema = Schema, exports.addCustomTypes = addCustomTypes;